export default {
    name: 'OperationsPage',

    data() {
        return {
            menu: [
                {
                    detail: true,
                    button: true,
                    text: 'Contacts',
                    url: '/action/operations/contacts'
                },
                {
                    detail: true,
                    button: true,
                    text: 'Building Fixtures',
                    url: '/action/operations/fixtures'
                },
                {
                    detail: true,
                    button: true,
                    text: 'Preparedness',
                    url: '/action/operations/preparedness'
                },
                {
                    detail: true,
                    button: true,
                    text: 'Recovery',
                    url: '/action/operations/recovery'
                }
            ]
        }
    },

    created() {
        this.$store.commit('setMenuItems', this.menu);
        this.$store.commit('setMenuDetails', { title: 'Operations', slug: 'operations', back_url: '/action' });
    }
};